/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseListUbiInsurerResponse } from '../models/ApiResponseListUbiInsurerResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UbiService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 보험사 목록 조회
   * 국가 및 안전운전점수에 따른 보험사 목록 조회. 점수 구간 미충족 보험사는 url이 null로 반환.
   * @returns ApiResponseListUbiInsurerResponse OK
   * @throws ApiError
   */
  public getInsurers({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListUbiInsurerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ubi/insurers',
      query: {
        'vin': vin,
      },
    });
  }
}
